import { MaxDisplayWidth } from '@/features/shared/constant';

export const isPhone = (): boolean => window.screen.width < MaxDisplayWidth.Phone;
export const isNotPhone = (): boolean => window.screen.width >= MaxDisplayWidth.Phone;

export const isIOS = (): boolean => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
